import {defineMessages} from 'react-intl';

export default defineMessages({
    all: {
        defaultMessage: 'All',
        description: 'Tag for filtering a library for everything',
        id: 'gui.libraryTags.all'
    },
    animals: {
        defaultMessage: '动物',
        description: 'Tag for filtering a library for animals',
        id: 'gui.libraryTags.animals'
    },
    dance: {
        defaultMessage: 'Dance',
        description: 'Tag for filtering a library for dance',
        id: 'gui.libraryTags.dance'
    },
    effects: {
        defaultMessage: '效果',
        description: 'Tag for filtering a library for effects',
        id: 'gui.libraryTags.effects'
    },
    fantasy: {
        defaultMessage: 'Fantasy',
        description: 'Tag for filtering a library for fantasy',
        id: 'gui.libraryTags.fantasy'
    },
    fashion: {
        defaultMessage: 'Fashion',
        description: 'Tag for filtering a library for fashion',
        id: 'gui.libraryTags.fashion'
    },
    food: {
        defaultMessage: 'Food',
        description: 'Tag for filtering a library for food',
        id: 'gui.libraryTags.food'
    },
    indoors: {
        defaultMessage: 'Indoors',
        description: 'Tag for filtering a library for indoors',
        id: 'gui.libraryTags.indoors'
    },
    loops: {
        defaultMessage: '循环音乐',
        description: 'Tag for filtering a library for loops',
        id: 'gui.libraryTags.loops'
    },
    music: {
        defaultMessage: 'Music',
        description: 'Tag for filtering a library for music',
        id: 'gui.libraryTags.music'
    },
    notes: {
        defaultMessage: '音符',
        description: 'Tag for filtering a library for notes',
        id: 'gui.libraryTags.notes'
    },
    outdoors: {
        defaultMessage: 'Outdoors',
        description: 'Tag for filtering a library for outdoors',
        id: 'gui.libraryTags.outdoors'
    },
    patterns: {
        defaultMessage: 'Patterns',
        description: 'Tag for filtering a library for patterns',
        id: 'gui.libraryTags.patterns'
    },
    people: {
        defaultMessage: '人物',
        description: 'Tag for filtering a library for people',
        id: 'gui.libraryTags.people'
    },
    percussion: {
        defaultMessage: '打击乐器',
        description: 'Tag for filtering a library for percussion',
        id: 'gui.libraryTags.percussion'
    },
    space: {
        defaultMessage: 'Space',
        description: 'Tag for filtering a library for space',
        id: 'gui.libraryTags.space'
    },
    sports: {
        defaultMessage: 'Sports',
        description: 'Tag for filtering a library for sports',
        id: 'gui.libraryTags.sports'
    },
    underwater: {
        defaultMessage: 'Underwater',
        description: 'Tag for filtering a library for underwater',
        id: 'gui.libraryTags.underwater'
    },
    voice: {
        defaultMessage: '人声',
        description: 'Tag for filtering a library for voice',
        id: 'gui.libraryTags.voice'
    },
    wacky: {
        defaultMessage: 'Wacky',
        description: 'Tag for filtering a library for wacky',
        id: 'gui.libraryTags.wacky'
    },
    plant_and_zombie: {
        defaultMessage: '植物与僵尸',
        description: 'Tag for filtering a library for plant_and_zombie',
        id: 'gui.libraryTags.plant_and_zombie'
    },
    three_kingdoms: {
        defaultMessage: '三国演义',
        description: 'Tag for filtering a library for three_kingdoms',
        id: 'gui.libraryTags.three_kingdoms'
    },
    magic_frame: {
        defaultMessage: '魔法相框',
        description: 'Tag for filtering a library for magic_frame',
        id: 'gui.libraryTags.magic_frame'
    },
    fighter: {
        defaultMessage: '小斗士',
        description: 'Tag for filtering a library for fighter',
        id: 'gui.libraryTags.fighter'
    },
    angry_bird: {
        defaultMessage: '愤怒的小鸟',
        description: 'Tag for filtering a library for angry_bird',
        id: 'gui.libraryTags.angry_bird'
    },
    guard_army: {
        defaultMessage: '皇家守卫军',
        description: 'Tag for filtering a library for guard_army',
        id: 'gui.libraryTags.guard_army'
    },
    topic_design: {
        defaultMessage: '主题设计课',
        description: 'Tag for filtering a library for topic_design',
        id: 'gui.libraryTags.topic_design'
    },
    spring: {
        defaultMessage: '春节',
        description: 'Tag for filtering a library for spring',
        id: 'gui.libraryTags.spring'
    },
    christmas: {
        defaultMessage: '圣诞节',
        description: 'Tag for filtering a library for christmas',
        id: 'gui.libraryTags.christmas'
    },
    new_year: {
        defaultMessage: '元旦',
        description: 'Tag for filtering a library for new_year',
        id: 'gui.libraryTags.new_year'
    },
    teachers_day: {
        defaultMessage: '教师节',
        description: 'Tag for filtering a library for teachers_day',
        id: 'gui.libraryTags.teachers_day'
    },
    mid_autumn_day: {
        defaultMessage: '中秋节',
        description: 'Tag for filtering a library for mid_autumn_day',
        id: 'gui.libraryTags.mid_autumn_day'
    },
    sniper_gangsters: {
        defaultMessage: '狙击匪徒',
        description: 'Tag for filtering a library for sniper_gangsters',
        id: 'gui.libraryTags.sniper_gangsters'
    },
    mothers_day: {
        defaultMessage: '母亲节',
        description: 'Tag for filtering a library for mothers_day',
        id: 'gui.libraryTags.mothers_day'
    },
    electronic: {
        defaultMessage: '电子',
        description: 'Tag for filtering a library for electronic',
        id: 'gui.libraryTags.electronic'
    },
    instruments: {
        defaultMessage: '乐器',
        description: 'Tag for filtering a library for instruments',
        id: 'gui.libraryTags.instruments'
    },
    vocals: {
        defaultMessage: '歌声',
        description: 'Tag for filtering a library for vocals',
        id: 'gui.libraryTags.vocals'
    },
    super_hero: {
        defaultMessage: '超级英雄',
        description: 'Tag for filtering a library for super_hero',
        id: 'gui.libraryTags.super_hero'
    },
    three_animals: {
        defaultMessage: '三只小动物',
        description: 'Tag for filtering a library for three_animals',
        id: 'gui.libraryTags.three_animals'
    },
    dragon_boat_festival: {
        defaultMessage: '端午节',
        description: 'dragon boat festival',
        id: 'gui.libraryTags.dragon_boat_festival'
    },
    transportation: {
        defaultMessage: '运输工具',
        description: 'transportation tool',
        id: 'gui.libraryTags.transportation'
    },
    things: {
        defaultMessage: 'things',
        description: 'things',
        id: 'gui.libraryTags.things'
    },
    dress_up: {
        defaultMessage: '装扮',
        description: 'the element of dress-up',
        id: 'gui.libraryTags.dress-up'
    },
    city: {
        defaultMessage: '城市',
        description: 'the element of city',
        id: 'gui.libraryTags.city'
    },
    flying: {
        defaultMessage: '飞行',
        description: 'the element of flying',
        id: 'gui.libraryTags.flying'
    },
    letters: {
        defaultMessage: '字母',
        description: 'letters',
        id: 'gui.libraryTags.letters'
    }
});
